import { NavigationItem } from "../model";

export const sleep = async (duration: number) => {
  await new Promise((resolve) => setTimeout(resolve, duration));
};

export const filterNavigationItems = (parent: string, level: number, items: NavigationItem[]): NavigationItem[] => {
  return items.filter((item) => item.path.startsWith(parent));
};
